var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"mgb80"},[_c('div',{staticClass:"content-web"},[_c('div',{staticClass:"inner_content_right"},[_c('div',{staticClass:"wp_single wp_column_article"},[_c('div',{staticClass:"wp_entry"},[_c('div',{staticClass:"wp_articlecontent"},[_c('div',{staticClass:"head"})])])])])])])])
}]

export { render, staticRenderFns }